import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivityLogs } from '../models/activity-logs';


@Injectable({
  providedIn: 'root'
})
export class activityLogService {

  constructor(private http: HttpClient) { }

  async index(): Promise<ActivityLogs> {
    return this.http.get<ActivityLogs>(`/api/activityLogs/index`).toPromise();
  }

  async store(activity: ActivityLogs): Promise<ActivityLogs> {
    return this.http.post<ActivityLogs>('/api/activityLogs/store', activity).toPromise();
  }
}
